import PropTypes from 'prop-types';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Spinner component - replacement for MUI CircularProgress
 *
 * @param {Object} props
 * @param {number} [props.size=24] - Size of the spinner in pixels
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.color] - Color of the spinner (CSS color value)
 */
export function Spinner({ size = 24, className, color, ...props }) {
  return (
    <Loader2
      className={cn('animate-spin', className)}
      size={size}
      style={color ? { color } : undefined}
      {...props}
    />
  );
}

Spinner.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  color: PropTypes.string,
};
